<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h1 class="title">Editar: {{currentPrivatePlan.titulo }}</h1>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
          </div>
          <div class="popup-body">
            <h3 v-if="currentPrivatePlan.id != null" class="subtitle">ID del taller: {{ currentPrivatePlan.id }}</h3>
            <h3 v-else class="subtitle">Nuevo taller privado</h3>
         
            <h4 style="margin-bottom: 0px;">Datos del taller privado</h4>
            <div class="fields">
              <div class="input-100">
                <label>Título*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.titulo"/>
              </div>
            </div>
            <div class="fields">
              <div class="input-100">
                <label>Observaciones*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.observaciones"/>
              </div>

            </div>
            <div class="fields" style="margin-top: 20px;">
              <div class="input-33">
                <label>Email de la empresa*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.empresa_email"/>
              </div>
              <div class="input-33">
                <label>Dirección*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.direccion"/>
              </div>
              <div class="input-33">
                <label>Ciudad*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.ciudad"/>
              </div>
            </div>
            <div class="fields" style="margin-top: 20px;">
              <div class="input-50">
                <label>Fecha*</label>
                <br/>
                <input
                  type="date"
                  required
                  class="expiration-date"
                  v-model="fecha" />
              </div>
              <div class="input-50">
                <label>Hora*</label>
                <br/>
                <input
                  type="time"
                  required
                  v-model="hora"/>
              </div>
            </div>
            <div class="fields" style="margin-top: 20px;">
              <div class="input-25">
                <label>Plazas*</label>
                <br/>
                <input
                  type="number"
                  required
                  :disabled="currentPrivatePlan.pago_final_estado == true"
                  v-model="currentPrivatePlan.num_plazas"
                  @input="updateTotalPrice" />
              </div>
              <div class="input-25">
                <label>Precio por plaza*</label>
                <br/>
                <input
                  type="number"
                  step="0.01"
                  required
                  :disabled="currentPrivatePlan.pago_final_estado == true"
                  v-model="currentPrivatePlan.precio_por_plaza"
                  @input="updateTotalPrice"
                  @blur="formatPrecioPorPlaza" />
              </div>
              <div class="input-25">
                <label>Total</label>
                <br/>
                <input
                  type="number"
                  step="0.01"
                  required
                  disabled
                  v-model="currentPrivatePlan.precio_total"/>
              </div>
              <div class="input-25">
                <label>GGE</label>
                <br/>
                <input
                  type="number"
                  step="0.01"
                  required
                  v-model="currentPrivatePlan.gge" />
              </div>
            </div>
            <h4 style="margin-top: 30px; margin-bottom: 0px;">Usuario</h4>
            <div class="fields">
              <div class="input-50">
                <label>Nombre del usuario*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.usuario_nombre" />
              </div>
              <div class="input-50">
                <label>Email del usuario*</label>
                <br/>
                <input
                  type="text"
                  required
                  v-model="currentPrivatePlan.usuario_email" />
              </div>
            </div>
            <h4 style="margin-top: 30px; margin-bottom: 0px;">Pagos</h4>
            <div class="fields">
              <div class="input-33 input-checkbox" style="margin-top: 10px; margin-bottom: 15px;">
                <label class="checkbox-label">
                  <input 
                    type="checkbox" 
                    v-model="singlePayment" 
                    @change="updateTotalPrice" 
                    :disabled="currentPrivatePlan.pago_inicial_estado == true" />
                  Pago único
                </label>
              </div>

              <div class="input-33">
                <label v-if="currentPrivatePlan.pago_inicial_estado == true">Pago inicial (Pagado)</label>
                <label v-else>Pago inicial (Pendiente)</label>
                <br/>
                <input
                  type="number"
                  step="0.01"
                  required
                  disabled
                  v-model="currentPrivatePlan.pago_inicial_cantidad" />
              </div>
              <div class="input-33">
                <label v-if="currentPrivatePlan.pago_final_estado == true">Pago final (Pagado)</label>
                <label v-else>Pago final (Pendiente)</label>
                <br/>
                <input
                  type="number"
                  step="0.01"
                  required
                  disabled
                  v-model="currentPrivatePlan.pago_final_cantidad" />
              </div>
            </div>
          </div>
          <div class="popup-footer-payment-urls-container">
            <label v-if="currentPrivatePlan.id != null" style="margin-right: 20px;" @click="onCopyInitialPaymentUrlClicked()">{{ initialCopied ? '¡Copiado!' : 'Copiar URL del Pago Inicial'}}</label>
            <label v-if="currentPrivatePlan.id != null && !singlePayment" style="margin-left: 20px;" @click="onCopyFinalPaymentUrlClicked()">{{ finalCopied ? '¡Copiado!' : 'Copiar URL del Pago Final'}}</label>
            <label v-if="currentPrivatePlan.id == null">Una vez guardado el plan, aquí aparecerán las urls de pago para poder copiarlas.</label>
          </div>
          <div class="popup-footer">
            <button v-if="currentPrivatePlan.pago_inicial_estado == false" @click="onSendInitialPaymentClicked()" class="secondary_button" style="margin-right: auto;">Enviar email de pago inicial</button>
            <button @click="closePopup()" class="secondary_button">Cancelar</button>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import { useLoadingStore } from "@/stores/loadingStore";
  import { refreshToken } from "@/services/authService";
  import { useRouter } from 'vue-router';
  
  const props = defineProps({
    privatePlan: Object,
  });

  const emit = defineEmits(['privatePlanChanged', 'privatePlanChangedWithoutClosing', 'privatePlanDetailsPopupCancelled', 'privatePlanDetailsErrorHappened']);

  const visible = ref(false);
  const currentPrivatePlan = ref(null);
  const loadingStore = useLoadingStore();
  const router = useRouter();
  const fecha = ref(null);
  const hora = ref(null);
  const singlePayment = ref(false);
  const initialCopied = ref(false);
  const finalCopied = ref(false);

  watch(() => props.privatePlan, (newVal) => {
    currentPrivatePlan.value = newVal;
    if (newVal) {
      if (currentPrivatePlan.value.precio_por_plaza !== null && currentPrivatePlan.value.precio_por_plaza !== undefined) {
        currentPrivatePlan.value.precio_por_plaza = Number(currentPrivatePlan.value.precio_por_plaza).toFixed(2);
      }
      if (currentPrivatePlan.value.precio_total !== null && currentPrivatePlan.value.precio_total !== undefined) {
        currentPrivatePlan.value.precio_total = Number(currentPrivatePlan.value.precio_total).toFixed(2);
      }
      if (currentPrivatePlan.value.pago_inicial_cantidad !== null && currentPrivatePlan.value.pago_inicial_cantidad !== undefined) {
        currentPrivatePlan.value.pago_inicial_cantidad = Number(currentPrivatePlan.value.pago_inicial_cantidad).toFixed(2);
      }
      if (currentPrivatePlan.value.pago_final_cantidad !== null && currentPrivatePlan.value.pago_final_cantidad !== undefined) {
        currentPrivatePlan.value.pago_final_cantidad = Number(currentPrivatePlan.value.pago_final_cantidad).toFixed(2);
      }
      singlePayment.value = currentPrivatePlan.value.pago_final_cantidad == 0 && currentPrivatePlan.value.pago_inicial_cantidad > 0;
    }

    if (newVal && newVal.fecha) {
      const parts = newVal.fecha.split(' ');
      if (parts.length > 0) {
        fecha.value = parts[0];
      }
      if (parts.length > 1) {
        hora.value = parts[1].substring(0, 5);
      } else {
        hora.value = '';
      }
    } else {
      fecha.value = null;
      hora.value = null;
    }
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    currentPrivatePlan.value = null;
    emit('privatePlanDetailsPopupCancelled');
  };

  const updateTotalPrice = () => {
    if (currentPrivatePlan.value) {
      const total = (Number(currentPrivatePlan.value.num_plazas) || 0) * 
                    (Number(currentPrivatePlan.value.precio_por_plaza) || 0);
      currentPrivatePlan.value.precio_total = total.toFixed(2);
      if (currentPrivatePlan.value.pago_inicial_estado == false) {
        if (singlePayment.value) {
          currentPrivatePlan.value.pago_inicial_cantidad = total.toFixed(2);
        } else {
          currentPrivatePlan.value.pago_inicial_cantidad = (total * 0.3).toFixed(2);
        }
      }
      const pagoInicial = Number(currentPrivatePlan.value.pago_inicial_cantidad) || 0;
      currentPrivatePlan.value.pago_final_cantidad = (total - pagoInicial).toFixed(2);
    }
  };

  const formatPrecioPorPlaza = () => {
    if (currentPrivatePlan.value && currentPrivatePlan.value.precio_por_plaza !== null && currentPrivatePlan.value.precio_por_plaza !== '') {
      currentPrivatePlan.value.precio_por_plaza = Number(currentPrivatePlan.value.precio_por_plaza).toFixed(2);
      updateTotalPrice();
    }
  };
  
  const sendInitialPayment = async () => {
      loadingStore.setLoading(true)
      try {
        let response = await sendInitialPaymentInAPI();

        if (response.status === 401) {
          const refreshed = await refreshToken();
          if (refreshed) {
            response = await sendInitialPaymentInAPI();
          } else {
            loadingStore.setLoading(false);
            localStorage.removeItem('user_id');
            localStorage.removeItem('token');
            router.push('/');
            return;
          }
        }

        if (!response.ok) {
          emit('privatePlanDetailsErrorHappened', 'Se ha producido un error enviando el email de pago inicial: ' + response.message);
          loadingStore.setLoading(false);
          return;
        }

        const data = await response.json();

        if (data.errors) {
          emit('privatePlanDetailsErrorHappened', data.message);
          loadingStore.setLoading(false);
        } else {
          loadingStore.setLoading(false);
      }      
    } catch (exception) {
      emit('privatePlanDetailsErrorHappened', exception.message);
    }
  };

  const onSendInitialPaymentClicked = async () => {
    if (currentPrivatePlan.value.id != null) {
        await sendInitialPayment();
    } else {
      emit('privatePlanDetailsErrorHappened', 'El taller privado debe ser guardado antes de enviar el email de pago inicial.');
    }
  };

  async function sendInitialPaymentInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/private_plans/send_initial_payment_request", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "plan_id": currentPrivatePlan.value.id
      }),
    });
  
  }

  const saveClicked = async () => {
    loadingStore.setLoading(true);

    let formattedDate = null;
    if (fecha.value) {
      const formattedHora = hora.value ? (hora.value.length === 5 ? hora.value + ':00' : hora.value) : '00:00:00';
      formattedDate = `${fecha.value} ${formattedHora}`;
    }
    currentPrivatePlan.value.fecha = formattedDate;

    try {
      let response = await savePrivatePlanInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await savePrivatePlanInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return false;
        }
      }

      if (!response.ok) {
        emit('privatePlanDetailsErrorHappened', 'Se ha producido un error guardando el taller privado.');
        loadingStore.setLoading(false);
        return false;
      }

      const data = await response.json();

      if (data.errors) {
        emit('privatePlanDetailsErrorHappened', data.message);
        loadingStore.setLoading(false);
        return false;
      } else {
        loadingStore.setLoading(false);
        emit('privatePlanChanged');
        return true;
    }      
    } catch (exception) {
      emit('privatePlanDetailsErrorHappened', exception.message);
      return false;
    }
  }

  async function savePrivatePlanInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/private_plans/set_details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "plan": currentPrivatePlan.value
      }),
    });
  }

  function onCopyInitialPaymentUrlClicked() {
    navigator.clipboard.writeText(currentPrivatePlan.value.initial_payment_url);
    initialCopied.value = true;
    setTimeout(() => {
      initialCopied.value = false;
    }, 2000);
  }

  function onCopyFinalPaymentUrlClicked() {
    navigator.clipboard.writeText(currentPrivatePlan.value.final_payment_url);
    finalCopied.value = true;
    setTimeout(() => {
      finalCopied.value = false;
    }, 2000);
  }

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 90%;
    max-width: 1800px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-height: 90vh;
  }
  
  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .popup-footer-payment-urls-container {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: center;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 120px;
  }

  .popup {
    position: relative;
  }

  .button-disabled {
    opacity: 0.5;
  }

  .button-enabled {
    opacity: 1;
  }

  .title {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .subtitle {
    text-align: center;
  }

  .fields {
    display: flex;
  }

  .input-25 {
    flex: 0 0 24%;
    margin-right: 1%;
  }

  .input-25:last-child {
    flex: 0 0 25%;
    margin-right: 0%;
  }

  .input-25 input {
    width: 100%;
    box-sizing: border-box;
  }

  .input-25 select {
    width: 100%;
    box-sizing: border-box;
    height: 46px;
  }

  .input-33 {
    flex: 0 0 32.3%;
    margin-right: 1%;
  }

  .input-33:last-child {
    flex: 0 0 33.3%;
    margin-right: 0%;
  }

  .input-33 input {
    width: 100%;
    box-sizing: border-box;
  }

  .input-33 select {
    width: 100%;
    box-sizing: border-box;
    height: 46px;
  }

  .input-50 {
    flex: 0 0 49%;
    margin-right: 1%;
  }

  .input-50:last-child {
    flex: 0 0 50%;
    margin-right: 0%;
  }

  .input-50 input {
    width: 100%;
    box-sizing: border-box;
  }

  .input-50 select {
    width: 100%;
    box-sizing: border-box;
    height: 46px;
  }

  .input-66 {
    flex: 0 0 65.6%;
    margin-right: 1%;
  }

  .input-66:last-child {
    flex: 0 0 66.6%;
    margin-right: 0%;
  }

  .input-66 input {
    width: 100%;
    box-sizing: border-box;
  }

  .input-100 {
    flex: 0 0 100%;
  }

  .input-100 input {
    width: 100%;
    box-sizing: border-box;
  }

  .input-100 textarea {
    width: 100%;
    box-sizing: border-box;
  }

  .datepicker-container {
    width: 100%;
    margin-top: 0px;
    padding: 0px;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid var(--gray);
    background-color: white;
  }

  .content-preview {
    margin-top: 20px;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f9f9f9;
  }
  
  
  .input-checkbox {
    display: flex;
    align-items: center;
    margin-top: 15px;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
  }

  .fields input:disabled {
    background-color: var(--almost-white) !important;
    border-color: var(--white) !important;
  }

  .expiration-date {
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid var(--gray);
    background-color: var(--white);
  }

  .expiration-date-container {
    width: 100%;
    margin-top: 5px;
    padding: 0px;
    display: flex;
    justify-content: center;
  }

  .add_button {
    padding-top: 20px;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .action_icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin: 0px 5px;
  }

  .without-top-padding {
    padding-top: 0px !important;
  }

  .centered {
    justify-content: center !important;
  }

  .campo-pedir-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 10px;
  }
  </style>
  